export default __webpack_public_path__ + "static/media/folder.40884740.png";